/** Affiliates collapsed into one filter option. */
export const GROUPED_AFFILIATES = new Set(["UruBoPa", "CCAV"]);

export interface CountryFilterOptions {
  /** Option labels available per ts_region. */
  byRegion: Record<string, string[]>;
  /** Option label -> every country value a matching record may carry. */
  members: Record<string, string[]>;
}

export const buildCountryFilterOptions = (
  rows: any[] = [],
): CountryFilterOptions => {
  const byRegion: Record<string, Set<string>> = {};
  const members: Record<string, Set<string>> = {};

  rows.forEach((row) => {
    const name = row?.country_name;
    const region = row?.ts_region;
    if (!name || !region) return;

    const label = GROUPED_AFFILIATES.has(row?.affiliate) ? row.affiliate : name;

    if (!byRegion[region]) byRegion[region] = new Set();
    byRegion[region].add(label);

    if (!members[label]) members[label] = new Set();
    members[label].add(name);
  });

  const toSorted = (set: Set<string>) =>
    Array.from(set).sort((a, b) => a.localeCompare(b));

  return {
    byRegion: Object.fromEntries(
      Object.entries(byRegion).map(([region, set]) => [region, toSorted(set)]),
    ),
    members: Object.fromEntries(
      Object.entries(members).map(([label, set]) => [label, Array.from(set)]),
    ),
  };
};

/** Turns selected filter labels into the country values the backend matches on. */
export const expandCountryFilters = (
  selected: string[] = [],
  members: Record<string, string[]> = {},
): string[] =>
  Array.from(new Set(selected.flatMap((label) => members[label] || [label])));
